//
//    WARNING
//    This file was auto-generated by swagger-typescript-codegen.
//    Please do not make changes here because they may be overwritten.
//

import request from 'superagent';
import { ModelSummary } from './ModelService';
import {
  CallbackHandler,
  CommonRequestOptions,
  ConfigureAgentHandler,
  ConfigureRequestHandler,
  Logger,
  Parameter,
  ProblemDetails,
  QueryParameters,
  RequestHeaders,
  RequestHeadersHandler,
  ResponseWithBody,
} from './types';

export type CalculationDetails = {
  inputParameters?: Array<Parameter>;
  outputParameters?: Array<Parameter>;
};

export type CalculationDetailsCalculationMetaDataResponseWrapper = {
  data?: CalculationDetails;
  metadata?: CalculationMetaData;
};

export type CalculationInboundPayload = {
  inputParameters?: Array<CalculationInput>;
};

export type CalculationInput = {
  name?: string;
  returnInOutput?: boolean;
  type?: string;
  value?: {};
};

export type CalculationMetaData = {
  calculationId?: string;
};

export type CalculationOutput = {
  name?: string;
  passthrough?: boolean;
  value?: {};
};

export type CalculationOutputArrayCalculationMetaDataResponseWrapper = {
  data?: Array<CalculationOutput>;
  metadata?: CalculationMetaData;
};

export type ModelSummaryArrayCalculationMetaDataResponseWrapper = {
  data?: Array<ModelSummary>;
  metadata?: CalculationMetaData;
};

/**
 * Insight2Profit CalculationService
 * @class CalculationService
 * @param {(string)} [domainOrOptions] - The project domain.
 */
export class CalculationService {
  private domain: string = '';
  private errorHandlers: CallbackHandler[] = [];
  private requestHeadersHandler?: RequestHeadersHandler;
  private configureAgentHandler?: ConfigureAgentHandler;
  private configureRequestHandler?: ConfigureRequestHandler;

  constructor(domain?: string, private logger?: Logger) {
    if (domain) {
      this.domain = domain;
    }
  }

  getDomain() {
    return this.domain;
  }

  addErrorHandler(handler: CallbackHandler) {
    this.errorHandlers.push(handler);
  }

  setRequestHeadersHandler(handler: RequestHeadersHandler) {
    this.requestHeadersHandler = handler;
  }

  setConfigureAgentHandler(handler: ConfigureAgentHandler) {
    this.configureAgentHandler = handler;
  }

  setConfigureRequestHandler(handler: ConfigureRequestHandler) {
    this.configureRequestHandler = handler;
  }

  private request(
    method: string,
    url: string,
    body: any,
    headers: RequestHeaders,
    queryParameters: QueryParameters,
    form: any,
    reject: CallbackHandler,
    resolve: CallbackHandler,
    opts: CommonRequestOptions
  ) {
    if (this.logger) {
      this.logger.log(`Call ${method} ${url}`);
    }

    const agent = this.configureAgentHandler ? this.configureAgentHandler(request) : request;

    let req = agent(method, url);
    if (this.configureRequestHandler) {
      req = this.configureRequestHandler(req);
    }

    req = req.query(queryParameters);

    if (body) {
      req.send(body);

      if (typeof body === 'object' && !(body.constructor.name === 'Buffer')) {
        headers['Content-Type'] = 'application/json';
      }
    }

    headers['x-insight-ns'] = 'master';

    if (Object.keys(form).length > 0) {
      req.type('form');
      req.send(form);
    }

    if (this.requestHeadersHandler) {
      headers = this.requestHeadersHandler({
        ...headers,
      });
    }

    req.set(headers);

    if (opts.$retries && opts.$retries > 0) {
      req.retry(opts.$retries);
    }

    if ((opts.$timeout && opts.$timeout > 0) || (opts.$deadline && opts.$deadline > 0)) {
      req.timeout({
        deadline: opts.$deadline,
        response: opts.$timeout,
      });
    }

    req.end((error, response) => {
      // an error will also be emitted for a 4xx and 5xx status code
      // the error object will then have error.status and error.response fields
      // see superagent error handling: https://github.com/visionmedia/superagent/blob/master/docs/index.md#error-handling
      if (error) {
        reject(error);
        this.errorHandlers.forEach((handler) => handler(error));
      } else {
        resolve(response);
      }
    });
  }

  getCalculationsURL(
    parameters: {
      clientId: string;
    } & CommonRequestOptions
  ): string {
    let queryParameters: QueryParameters = {};
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/ces/clients/{clientId}/calculations';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    path = path.replace('{clientId}', `${parameters['clientId']}`);

    if (parameters.$queryParameters) {
      queryParameters = {
        ...queryParameters,
        ...parameters.$queryParameters,
      };
    }

    let keys = Object.keys(queryParameters);
    return (
      domain +
      path +
      (keys.length > 0 ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&') : '')
    );
  }

  /**
   *
   * @method
   * @name CalculationService#getCalculations
   * @param {string} clientId - Insight2Profit CalculationService
   */
  getCalculations(
    parameters: {
      clientId: string;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, ModelSummaryArrayCalculationMetaDataResponseWrapper>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/ces/clients/{clientId}/calculations';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  getCalculationsByIdURL(
    parameters: {
      clientId: string;
      id: string;
    } & CommonRequestOptions
  ): string {
    let queryParameters: QueryParameters = {};
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/ces/clients/{clientId}/calculations/{id}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    path = path.replace('{clientId}', `${parameters['clientId']}`);

    path = path.replace('{id}', `${parameters['id']}`);

    if (parameters.$queryParameters) {
      queryParameters = {
        ...queryParameters,
        ...parameters.$queryParameters,
      };
    }

    let keys = Object.keys(queryParameters);
    return (
      domain +
      path +
      (keys.length > 0 ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&') : '')
    );
  }

  /**
   *
   * @method
   * @name CalculationService#getCalculationsById
   * @param {string} clientId - Insight2Profit CalculationService
   * @param {string} id - Insight2Profit CalculationService
   */
  getCalculationsById(
    parameters: {
      clientId: string;
      id: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, CalculationDetailsCalculationMetaDataResponseWrapper> | ResponseWithBody<400, ProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/ces/clients/{clientId}/calculations/{id}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  postCalculationsByModelIdURL(
    parameters: {
      clientId: string;
      modelId: string;
      body: CalculationInboundPayload;
    } & CommonRequestOptions
  ): string {
    let queryParameters: QueryParameters = {};
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/ces/clients/{clientId}/calculations/{modelId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    path = path.replace('{clientId}', `${parameters['clientId']}`);

    path = path.replace('{modelId}', `${parameters['modelId']}`);

    if (parameters.$queryParameters) {
      queryParameters = {
        ...queryParameters,
        ...parameters.$queryParameters,
      };
    }

    queryParameters = {};

    let keys = Object.keys(queryParameters);
    return (
      domain +
      path +
      (keys.length > 0 ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&') : '')
    );
  }

  /**
   *
   * @method
   * @name CalculationService#postCalculationsByModelId
   * @param {string} clientId - Insight2Profit CalculationService
   * @param {string} modelId - Insight2Profit CalculationService
   * @param {} body - Insight2Profit CalculationService
   */
  postCalculationsByModelId(
    parameters: {
      clientId: string;
      modelId: string;
      body: CalculationInboundPayload;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, CalculationOutputArrayCalculationMetaDataResponseWrapper>
    | ResponseWithBody<400, ProblemDetails>
    | ResponseWithBody<401, ProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/ces/clients/{clientId}/calculations/{modelId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['Accept'] = 'application/json';
      headers['Content-Type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{modelId}', `${parameters['modelId']}`);

      if (parameters['modelId'] === undefined) {
        reject(new Error('Missing required  parameter: modelId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  getReadyzURL(parameters: {} & CommonRequestOptions): string {
    let queryParameters: QueryParameters = {};
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/readyz';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    if (parameters.$queryParameters) {
      queryParameters = {
        ...queryParameters,
        ...parameters.$queryParameters,
      };
    }

    let keys = Object.keys(queryParameters);
    return (
      domain +
      path +
      (keys.length > 0 ? '?' + keys.map((key) => key + '=' + encodeURIComponent(queryParameters[key])).join('&') : '')
    );
  }

  /**
   *
   * @method
   * @name CalculationService#getReadyz
   */
  getReadyz(parameters: {} & CommonRequestOptions): Promise<ResponseWithBody<200, void>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/readyz';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }
}

export default CalculationService;
